import { PictureAsPdf } from '@mui/icons-material';
import { IconButton, Link, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback, useState } from 'react';
import { ReactComponent as LinkIcon } from '../../../assets/icons/expand-link.svg';
import { CompanyFile } from '../../../types/files';
import { s3Download } from '../../../helpers/s3';
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download.svg";

const useStyles = makeStyles((theme) => ({
    fileLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.spacing(1),
        textDecoration: 'none',
        fontFamily: 'Lato',
        fontWeight: 600,
        fontSize: 14,
        transition: 'background 0.2s',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        "&:hover": {
            textDecoration: 'none !important',
        },
    },
    fileLinkPdf: {
        color: '#c62828',
        backgroundColor: '#ffebee',
        '&:hover': {
            backgroundColor: '#ffcdd2',
        },
    },
    fileLinkRegular: {
        color: '#1976d2',
        backgroundColor: '#e3f2fd',
        '&:hover': {
            backgroundColor: '#bbdefb',
        },
    },
    iconWrapper: {
        padding: 6,
        border: '1px solid #e9ecef',
        borderRadius: 8,
        background: '#fff',
        "&:hover": {
            border: '1px solid #67acaf',
        }
    },
    donwloadIcon: {
        width: 18,
        height: 18,
        stroke: '#898d91',
        "&:hover": {
            stroke: '#67acaf',
        }
    },
}));

const FileAttachment: React.FC<{
    resName: string;
    file?: CompanyFile;
    isPdf?: boolean
}> = ({ resName, file, isPdf = false }) => {
    const classes = useStyles();
    const [hover, setHover] = useState<boolean>(false);

	const sanitizeUrl = (originUrl: string) => originUrl.replace(/^https?:\/\//, '').replace(/^www\./, '');

    const downloadURL = useCallback((data: any, fileName: any) => {
        const a: any = document.createElement('a');
        a.href = data;
        a.download = fileName;
        document.body.appendChild(a);
        a.style = 'display: none';
        a.click();
        a.remove();
    }, []);

    const downloadBlob = useCallback((data: any, fileName: string, mimeType: string) => {
        const blob = new Blob([data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        downloadURL(url, fileName);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }, [downloadURL]);

    const downloadFile = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!!file?.key) {
            s3Download({ key: file.key }).then((payload) => {
                downloadBlob(payload, `${file.name}.pdf`, "application/octet-stream");
            });
        }
    // eslint-disable-next-line
    }, [file]);

	return (
        <Stack width="100%" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                <Link className={`${classes.fileLink} ${isPdf ? classes.fileLinkPdf : classes.fileLinkRegular}`}
                    href={!isPdf ? resName : '#'}
                    rel={!isPdf ? 'noopener noreferrer' : undefined}
                    target={!isPdf ? '_blank' : undefined}
                    underline="none">
                    {isPdf ? ( <PictureAsPdf sx={{ width: 16, height: 16 }} /> )
                        : ( <LinkIcon style={{ width: 16, height: 16 }} /> )}
                    {isPdf ? resName : sanitizeUrl(resName)}
                </Link>
                {!!file && hover && (
                    <IconButton onClick={downloadFile}
                        className={classes.iconWrapper} disableRipple>
                        <DownloadIcon className={classes.donwloadIcon} />
                    </IconButton>
                )}
            </Stack>

        </Stack>
	);
};

export default FileAttachment;